
<template>
  <div style="position: fixed; width: 100%; height: 100%; top:0; left: 0; background-color: rgba(0,0,0,0.6);">
    <div style="position: absolute; top:50%; left:50%; transform: translate(-50%, -50%); width: calc(100% - 20px); max-width: 1500px; height: 90%; background-color: white; border-radius: 10px; padding: 10px;">
      <div style="width: 100%; height: calc(100% - 80px); overflow-y: auto;">
        <div class="container-fluid" v-if="item != null">
          <div class="row section-container">
            <div class="col-8 text-left">
              <h2>Manifest</h2>
            </div>
            <div class="col-4 text-right">
              <button v-on:click="printManifest()">Print</button>
            </div>
          </div>
          <div class="row section-container" style="display: none;">
            <div class="col-4">
              <div class="container-fluid">
                <div class="form-group row">
                  <div class="col-4 pa-0"><label>Airline</label></div>
                  <div class="col-8 pa-0">
                    <select class="form-control" v-model="item.issuerId" @change="onAirlineSelected">

                      <option v-for="airline in airlines" :key="'airline-selector-'+airline.id" :value="airline.id">{{airline.title}}</option>

                    </select>
                  </div>
                </div>
                <div class="form-group row" v-if="mawbs.length > 0">
                  <div class="col-4 pa-0"><label>Select MAWB</label></div>
                  <div class="col-8 pa-0">
                    <select class="form-control" v-model="item.mawbId" @change="onMawbSelected">
                      <option v-for="mawb in mawbs" :key="'mawb-selector-'+mawb.id" :value="mawb.id">{{mawb.airlineCode}}-{{mawb.number}}</option>

                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 pa-0"><label>AWB:</label></div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.awb" placeholder="AWB"
                           @change="onAWBEntered()"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 pa-0">DATE:</div>
                  <div class="col-8 pa-0">
                    <input type="date" class="form-control" v-model="item.cargoDate"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 pa-0">CARGO TYPE:</div>
                  <div class="col-8 pa-0">
                    <select class="form-control" v-model="item.cargoType">
                      <option value="UNKNOWN CARGO">UNKNOWN CARGO</option>
                      <option value="KNOWN CARGO">KNOWN CARGO</option>
                    </select>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-4">
              <div class="container-fluid">
                <div class="form-group row">
                  <div class="col-4 pa-0"><label>FLIGHT:</label></div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.flight" placeholder="FLIGHT"/>
                  </div>
                  <div class="col-4 pa-0"><label>FLIGHT2:</label></div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.flight2" placeholder="FLIGHT2"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 pa-0"><label>ORIGIN:</label></div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.origin" placeholder="ORIGIN"/>
                  </div>
                  <div class="col-4 pa-0"><label>DESTINATION:</label></div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.destination" placeholder="DEST"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 pa-0"><label>Departure Time</label></div>
                  <div class="col-8 pa-0"><input class="form-control" type="datetime-local" v-model="item.departureTime"/></div>
                </div>
                <div class="form-group row">
                  <div class="col-4 pa-0"><label>Arrival Time</label></div>
                  <div class="col-8 pa-0"><input class="form-control" type="datetime-local" v-model="item.arrivalTime"/></div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="container-fluid">
                <div class="form-group row">
                  <div class="col-4 pa-0">
                    Receiver:
                  </div>
                  <div class="col-8 pa-0">
                    <select class="form-control" v-model="item.agentId" @change="onManiReceiverSelected">
                      <option :value="0">Select</option>

                      <option v-for="item in customers" :key="'receiver-selector-'+item.id" :value="item.id">{{item.title}}</option>

                    </select>
                  </div>

                </div>
                <div class="form-group row">
                  <div class="col-4 pa-0">업체명</div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.agent"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 pa-0">우편번호</div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.postCode"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 pa-0">주소</div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.address1"/>
                  </div>
                  <!--            </div>-->
                  <!--            <div class="form-group row">-->
                  <div class="col-4 pa-0"></div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.address2"/>
                  </div>
                  <!--            </div>-->
                  <!--            <div class="form-group row">-->
                  <div class="col-4 pa-0"></div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.address3"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 pa-0">전화번호</div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.telephone"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-4 pa-0">FAX</div>
                  <div class="col-8 pa-0">
                    <input type="text" class="form-control" v-model="item.fax"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">

            <div class="col-12 text-left">
              <b>HOUSE</b> <button v-if="item.id > 0" class="btn btn-primary" @click="getCandidates"><i class="fas fa-plus"></i> 추가하기</button>
            </div>
            <div class="col-12">
              <table class="table">
                <tr>
                  <th class="text-left">#</th>
                  <th class="text-left">Shipper</th>
                  <th class="text-left">Consignee</th>
                  <th>NOP</th>
                  <th>GW / CW</th>
                  <th></th>
                </tr>
                <tr v-for="request in item.requests" :key="'house-item-' + request.id">
                  <td class="text-left">
                    <span v-if="request.house !== null">{{request.house.blNumber}}</span>
                    <span v-else>{{request.blNumber}} [{{request.id}}]</span>
                  </td>
                  <td class="text-left">
                    {{request.requester}}<br/>
                    {{request.addressFrom}}<br/>
                    {{request.shipperAddress2}}<br/>
                    {{request.shipperAddress3}}<br/>
                    {{request.shipperTel}}<br/>
                  </td>
                  <td class="text-left">
                    {{request.requester}}<br/>
                    {{request.addressTo}}<br/>
                    {{request.addressTel}}
<!--                    {{request.consigneeAddress2}}<br/>-->
<!--                    {{request.consigneeAddress3}}<br/>-->
<!--                    {{request.consigneeTel}}<br/>-->
                  </td>

                  <td>
                    {{request.qty}}
                  </td>
                  <td>
                    {{request.kg}}
                  </td>
                  <td>
                    <button v-if="request.house !== null" class="btn btn-success" @click="openHouseItem(request.house.id)">View HAWB</button>
                    <button v-if="request.house === null" class="btn btn-primary" @click="createHouseItem(request)">Create HAWB</button>
                    <button class="btn btn-danger" @click="unbindRequest(request)">Unbind</button>
                  </td>
                </tr>
              </table>
            </div>

          </div>

          <div class="container-fluid text-left house-bill" style="padding-bottom: 100px; margin-top: 50px;">
            <div class="row">
              <div class="col-12" style="font-weight: bold;">
                MASTER AIRWAY BILL
              </div>
            </div>

            <div class="row">
              <div class="col-6" style="padding-top: 10px; padding-bottom: 10px;">
               AWB: <input style="width: 100px; text-align: center;" v-model="item.awb1"/> - <input style="width: 100px; text-align: center;" v-model="item.awb2"/> <input style="width: 100px; text-align: center;" v-model="item.awb3"/>

              </div>
              <div class="col-6">
                <input style="width: 100%;" v-model="item.reference" placeholder="Reference"></input>

              </div>
            </div>
            <div class="row">
              <div class="col-6">
                Shipper's Name and Address
                <input class="form-control" v-model="item.shipper" placeholder="Shipper name"/>
                <input class="form-control" v-model="item.shipperAddress" placeholder="Address 1"/>
                <input class="form-control" v-model="item.shipperAddress2" placeholder="Address 2"/>
                <input class="form-control" v-model="item.shipperAddress3" placeholder="Address 3"/>
                <input class="form-control" v-model="item.shipperTel" placeholder="Telephone"/>
<!--                <br>-->
<!--                UKO Shipping Ltd-->
<!--                <br/>-->
<!--                Unit 7 Caker Stream Road-->
<!--                <br/>Alton, England-->
<!--                <br/>-->
<!--                GU34 2QA-->
<!--                <br/>-->
<!--                UNITED KINGDOM-->
              </div>
              <div class="col-6">
                HOUSE AIR WAYBILL
                <br>
                issued by<br>
                <input class="form-control" v-model="item.issuerTitle" placeholder="Airline Name"/>
                <input class="form-control" v-model="item.issuerAddress" placeholder="Address 1"/>
                <input class="form-control" v-model="item.issuerCountry" placeholder="Address 2"/>
<!--                {{item.issuerTitle}}<br>-->
<!--                {{item.issuerAddress}}<br>-->
<!--                {{item.issuerCountry}}-->
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                Consignee Name and Address <button @click="openAgentSelector('consignee', 'agents')">Search</button><br>
                <div style="width: 100%; display: flex;">
                  <div style="width: calc(100% - 100px);"><input class="form-control" v-model="item.consigneeTitle" :disabled="item.consigneeId > 0" placeholder="Name"/></div>
                  <div style="width: 100px;"><button v-if="item.consigneeId > 0" @click="item.consigneeId = 0; item.consigneeTitle = '';">Manual</button></div>
                </div>
                <!--              <input class="form-control" v-model="item.consigneeTitle" placeholder="Name"/>-->
                <input class="form-control" v-model="item.consigneeAddress1" placeholder="Address 1"/>
                <input class="form-control" v-model="item.consigneeAddress2" placeholder="Address 2"/>
                <input class="form-control" v-model="item.consigneeAddress3" placeholder="Address 3"/>
                <input class="form-control" v-model="item.consigneeTel" placeholder="Telephone"/>
                <input class="form-control" v-model="item.consigneeFax" placeholder="Fax"/>
                <!-- {{item.agent}}<br>
                {{item.postCode}}<br>
                {{item.address1}}<br>
                {{item.address2}}<br>
                {{item.address3}}<br>
                {{item.telephone}}<br>
                {{item.fax}}<br> -->
              </div>
              <div class="col-6">
                Accounting Information
                <br>
                <textarea rows="5" v-model="item.accountingInfo" class="form-control"/>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                Issuing Carrier's Agent Name and City
                <input class="form-control" v-model="item.carrierAgentName"/>
                <input class="form-control" v-model="item.carrierAgentAddress"/>
              </div>
              <div class="col-6">

              </div>
              <div class="col-3">
                Agent IATA code
                <br>
               <input v-model="item.iataCode" class="form-control"/>
              </div>
              <div class="col-3">
                Account No
                <input class="form-control" v-model="item.accountNumber"/>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                Airport of Department (Addr of First Carrier) and Requested Routing<br>
                {{item.origin}}
              </div>
            </div>

            <div class="row">
              <div class="col-1">
                to<br>
                <input v-model="item.to1" class="form-control"/>
              </div>
              <div class="col-2">
                by first Carrier
                <br>
                <input v-model="item.by1" class="form-control"/>

              </div>
              <div class="col-1">
                to<br>
                <input v-model="item.to2" class="form-control"/>
              </div>
              <div class="col-1">
                by
                <br>
                <input v-model="item.by2" class="form-control"/>

              </div>
              <div class="col-1">
                to<br>
                <input v-model="item.to3" class="form-control"/>
              </div>
              <div class="col-1">
                by
                <br>
                <input v-model="item.by3" class="form-control"/>

              </div>
              <div class="col-2">
                Currency<br>GBP
              </div>
              <div class="col-2">
                PP X X
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                Airport of Destination<br>
                {{item.destination}}
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                Handling information
                <textarea class="form-control" rows="3" v-model="item.handlingInformation"/>

              </div>
            </div>


            <div class="row">
              <div class="col-12 text-right">
<!--                <button class="btn btn-primary" v-on:click="getHouseTotalData">Calculate</button>-->

<!--                New GW: <input type="number" id="new-gw"/> New VW:<input type="number" id="new-vw"/> New CW: <input type="number" id="new-cw">-->
                <button class="btn btn-primary" v-on:click="changeManifestWeights">다시 계산하기</button>
              </div>
            </div>
            <div class="row">
              <div class="col-9">
                <table class="table">
                  <tr>
                    <th>No</th>
                    <th>GW</th>
                    <th>Kg/lb</th>
                    <th>CW</th>
                    <th style="max-width: 100px;">Rate</th>
                    <th>Total</th>
                  </tr>
                  <tr>
                    <td colspan="4"></td>
                    <td><input style="max-width: 100px;" v-model="item.rateFloat" class="form-control" @change="chargeChanged"/></td>
                    <td></td>
                  </tr>


                  <tr v-for="request in item.requests" :key="'house-goods-' + request.id">
                    <td>{{request.qty}}</td>
                    <td>{{request.kg}}</td>
                    <td>K</td>
                    <td>{{request.kg}}</td>
                    <td>{{formatPrice((request.chargeRate/100).toFixed(2))}}</td>
                    <td>{{formatPrice((request.chargeTotal/100).toFixed(2))}}</td>
                  </tr>
<!--                  <tr>-->
<!--                    <td>{{item.nop}}</td>-->
<!--                    <td>{{item.gw}}</td>-->
<!--                    <td>K</td>-->
<!--                    <td>{{item.cw}}</td>-->
<!--                    <td>{{formatPrice((item.rate/100).toFixed(2))}}</td>-->
<!--                    <td>{{formatPrice((item.total/100).toFixed(2))}}</td>-->
<!--                  </tr>-->
                  <tr>
                    <td colspan="6" class="text-center">
                      ***********************
                      <span><select style="width:200px; text-align:center;" v-model="item.cargoType">
                        <option value="UNKNOWN CARGO">UNKNOWN CARGO</option>
                        <option value="KNOWN CARGO">KNOWN CARGO</option>
                      </select>
                      </span>
                      ********************
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6" class="text-center">
                      24 HOURS CONTACT +44(0)7740646164
                    </td>
                  </tr>
                  <tr>
                    <td>{{item.nop}}</td>
                    <td>{{item.gw}}</td>
                    <td colspan="3"></td>
                    <td>{{formatPrice((item.total/100).toFixed(2))}}</td>
                  </tr>
                </table>

              </div>
              <div class="col-3">
                Natura and Qantity of Goods
                <br>
                <textarea v-model="item.goodsDescription" class="form-control" rows="10"/>
              </div>
            </div>

            <div class="row">
              <div class="col-4">

                <table class="table text-center">
                  <tr>
                    <th>Prepaid</th>
                    <th colspan="2">Weigth Change</th>
                    <th>Collect</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th colspan="2">Valuation Charge</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td colspan="2">{{formatPrice((item.total/100).toFixed(2))}}</td>
                    <td colspan="2"></td>
                  </tr>
                  <tr>
                    <th></th>
                    <th colspan="2">Tax</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                  </tr>
                  <tr>
                    <th></th>
                    <th colspan="2">Total other Charges Due Agent</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td colspan="2">{{formatPrice( ((Number(item.ahc)+Number(item.fsc)+Number(item.moc)+Number(item.avs))/100).toFixed(2))}}</td>
                    <td colspan="2"></td>
                  </tr>
                  <tr>
                    <th></th>
                    <th colspan="2">Total other Charges Due Carrier</th>
                    <th></th>
                  </tr>
                  <tr>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                  </tr>

                  <tr>
                    <th colspan="2">Total Prepaid</th>
                    <th colspan="2">Total Collect</th>
                  </tr>
                  <tr>
                    <td colspan="2">{{formatPrice( ((Number(item.total) + Number(item.ahc)+Number(item.fsc)+Number(item.moc)+Number(item.avs))/100).toFixed(2))}}</td>
                    <td colspan="2"></td>
                  </tr>
                </table>
              </div>
              <div class="col-8">


                <div class="container">
                  <div class="row">
                    <div class="col-12">
                      Other Charges
                      <br>
                      {{formatPrice( ((Number(item.ahc)+Number(item.fsc)+Number(item.moc)+Number(item.avs))/100).toFixed(2))}}
                    </div>
                  </div>
                  <div class="row" style="padding-top: 20px;">
                    <div class="col-3">
                      <b>AHC (C)</b>
                      <input class="form-control" v-model="item.ahcFloat" @change="updateOtherCharge"/>
                    </div>
                    <div class="col-3">
                      <b>FSC (C)</b>
                      <input class="form-control" v-model="item.fscFloat" @change="updateOtherCharge"/>
                    </div>
                    <div class="col-3">
                      <b>MOC (C)</b>
                      <input class="form-control" v-model="item.mocFloat" @change="updateOtherCharge"/>
                    </div>
                    <div class="col-3">
                      <b>AVS (C)</b>
                      <input class="form-control" v-model="item.avsFloat" @change="updateOtherCharge"/>
                    </div>
                  </div>

                  <div class="row" style="padding-top: 20px;">
                    <div class="col-12 text-center">
                      UK Shipping Ltd<br>
                      AS AGENTS FOR {{item.issuerTitle}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      Executed on (Date)
                      <input class="form-control" type="date" v-model="item.signedDate"/>

                    </div>
                    <div class="col-4">
                      Executed at (Place)
                      <input class="form-control" v-model="item.origin"/>

                    </div>
                    <div class="col-4">
                      signature
                      <input class="form-control" type="text" v-model="item.signedBy"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
<!--            <div class="row">-->
<!--              <div class="col-12" style="padding:10px;">-->
<!--                <button class="btn btn-dark" v-on:click="printAwb"><i class="fas fa-print"></i> Print AWB</button>-->

<!--                <button class="btn btn-dark" style="margin-left:20px;" v-on:click="printDeliveryNote"><i class="fas fa-print"></i> Print Delivery Note</button>-->
<!--                Delivery Vehicle: <input type="text" style="width:200px;" v-model="item.vehicleReg"/>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div style="width: 100%; height: 80px; border-top: 1px solid #b2b2b2; background: #f4f4f4;">
        <div class="container-fluid">

          <div class="row" style="margin-top:20px;">
            <div class="col-3">
              <div class="form-control btn btn-secondary" v-on:click="closeItemForm()">Close</div>
            </div>
            <div class="col-3">
              <div class="btn btn-danger" @click="deleteItem">Delete</div>
            </div>
            <div class="col-3">
              <button class="btn btn-dark" v-on:click="printAwb"><i class="fas fa-print"></i> Print AWB</button>
              <button class="btn btn-danger" @click="openEmailItem">EMAIL</button>
            </div>
            <div class="col-3">
              <div class="form-control btn btn-primary" v-on:click="submitManifest()"><span v-if="item.id == 0">CREATE</span><span
                v-if="item.id > 0">UPDATE</span></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="position: fixed; width: 100%; height: 100%; top:0; left: 0; background-color: rgba(0,0,0,0.6);" v-if="candidateView !== false" @click="candidateView = false">
      <div style="position: absolute; top:50%; left:50%; transform: translate(-50%, -50%); width: 500px; height: 70%; background-color: white; border-radius: 10px; padding: 10px;" v-on:click.stop="dummy">
        <div style="width: 100%; height: 50px; line-height: 50px; font-weight: bold; font-size: 20px;">
          이사 리스트 <input id="search-input" v-model="candidateView.searchWord" style="width:200px;" @change="searchList"/>
        </div>
        <div style="width: 100%; height: calc(100% - 50px); overflow-y: auto;">
          <ul class="list-group">
            <li class="list-group-item" style="cursor: pointer;" v-for="request in candidateView.requests" v-on:click="selectRequest(request)">
              <div>REF: {{request.reference}} [{{request.id}}] <b>{{request.shippingMode}}</b></div>
              <div>고객: {{request.requester}}</div>
              <div>이사일: {{request.packingDate}}</div>
              <div>전화: {{request.phoneNumber}}</div>
              <div>위치: {{request.addressFrom}}</div>
              <div>CBM: {{request.preCbm}}</div>

            </li>
          </ul>
        </div>
      </div>
    </div>
    <email-form v-if="emailItem !== false"
                :item="emailItem.item"
                :documents="emailItem.documents"
                :on-close="closeEmailItem">

    </email-form>
    <agent-selector-view
      v-if="agentSelector !== false"
      :on-close="closeAgentSelector"
      :request="agentSelector"></agent-selector-view>
    <air-house-view
      v-if="airHouseItem !== false"
      :item="airHouseItem"
      :manifest="item"
      :on-updated="onHouseItemUpdated"
      :on-close="onHouseItemClose"
      :on-deleted="onHouseItemDeleted"/>
  </div>
</template>
<script>

import {createHouse, getHouse, updateHouse} from "../api/houses";
import {generateOrderNumber, showDialog} from "../api/utils";
import {deleteManifest, printMawb, updateManifest} from "../api/manifests";
import {getAirlines, getMawbs} from "../api/airlines";
import AgentSelectorView from "./AgentSelectorView.vue";
import {searchRequests, updateRequest, updateRequests} from "../api/request";
import AirHouseView from "./AirHouseView.vue";
import EmailForm from "./EmailForm";
export default {
  name:'AirManifestView',
  data() {
    return {
      mawbs:[],
      pdfView: false,
      airlines:[],
      agentSelector: false,
      candidateView: false,
      airHouseItem: false,
      emailItem:false,
    }
  },
  components: {
    AgentSelectorView,
    AirHouseView,
    EmailForm,
  },
  props: {
    item: {
      type:Object,
      default: function() { return null;}
    },
    customers: {
      type:Array,
      default: function(){return [];}
    },
    onUpdated: {
      type: Function,
      default: null,
    },
    onDeleted: {
      type: Function,
      default: null,
    },
    onClosed: {
      type: Function,
      default: null,
    },
    agents: {
      type: Array,
      default: function(){return [];}
    },
    merchants: {
      type:Array,
      default:function(){return [];},
    },
    // airlines: {
    //   type:Array,
    //   default:function(){return [];},
    // },
  },
  created() {
  },
  mounted() {
    console.log("item");
    console.log(this.item);
    this.onStart();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  watch: {
    item: function() {
      console.log("item updated");
      console.log(this.item);
    }
  },
  methods: {
    dummy: function(){},
    onStart: function() {
      let self = this;

      if(this.item.list !== null && this.item.list.length > 0) {

        this.item.gw = 0;
        this.item.cw = 0;
        this.item.rate = 0;
        for(let i = 0 ; i < this.item.list.length ; i++) {
          console.log("add house " + i);
          console.log(this.item.list[i]);
          this.item.gw += this.item.list[i].gw;
          this.item.cw += this.item.list[i].cw;
          this.item.rate += this.item.list[i].rate;
          console.log('gw: ' + this.item.gw + ' cw:' + this.item.cw + ' rate:' + this.item.rate);
        }
        this.item.total = this.item.rate * this.item.cw;
      }
      getAirlines()
        .then(function(data) {
          if(data.success === true) {
            self.$data.airlines = data.item;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          console.log(err);
        })
    },
    onAWBEntered: function() {
      if (this.item == false) {
        return;
      }

      if (this.item.awb.length != 12) {
        showDialog( "AWB xxx-xxxxxxxx형식으로 입력해주세요 1 ");
        return;
      }

      if (!this.item.awb.includes("-")) {
        showDialog( "AWB xxx-xxxxxxxx형식으로 입력해주세요 2");
        return;
      }
      let words = this.item.awb.split("-");
      if (words.length != 2) {
        showDialog( "AWB xxx-xxxxxxxx형식으로 입력해주세요 3");
        return;
      }
      if (words[0].length != 3) {
        showDialog( "AWB xxx-xxxxxxxx형식으로 입력해주세요 4");
        return;
      }
      if (words[1].length != 8) {
        showDialog( "AWB xxx-xxxxxxxx형식으로 입력해주세요 5");
        return;
      }
      if (words[0] == '180') {
        this.item.flight = 'KE908';
        this.item.origin = 'LHR';
        this.item.destination = 'ICN';
      } else if (words[0] == '988') {
        this.item.flight = 'OZ522';
        this.item.origin = 'LHR';
        this.item.destination = 'ICN';
      }
    },
    onManiReceiverSelected: function () {
      this.item.consignee = '';
      this.item.consigneeAddress = '';
      console.log("receiver selected");
      for (let i = 0; i < this.customers.length; i++) {

        if (this.customers[i].id === this.item.receiverId) {
          console.log(this.customers[i]);
          this.item.agent = this.customers[i].title.toUpperCase();
          this.item.agentId = this.customers[i].id;
          this.item.postCode = this.customers[i].postCode.toUpperCase();
          this.item.address1 = this.customers[i].address.toUpperCase();
          // this.item.address2 = this.customers[i].address2.toUpperCase();
          // this.item.address3 = this.customers[i].address3.toUpperCase();
          this.item.telephone = this.customers[i].contact;
          // this.item.fax = this.customers[i].fax;
        }
      }


    },
    onAirlineSelected: function() {
      this.item.issuerTitle = '';
      this.item.issuerAddress = '';
      this.item.issuerCountry = '';
      for(let i = 0 ; i < this.airlines.length ; i++) {
        if(this.airlines[i].id == this.item.issuerId) {
          this.item.issuerTitle = this.airlines[i].title!==null?this.airlines[i].title.toUpperCase():'';
          this.item.issuerAddress = this.airlines[i].address1!==null?this.airlines[i].address1.toUpperCase():'';
          this.item.issuerCountry = this.airlines[i].country!==null?this.airlines[i].country.toUpperCase():'';
          this.item.accountingInfo = this.airlines[i].account!=null?this.airlines[i].account.toUpperCase():'';
          this.getMawbList();
          break;
        }
      }
    },
    getMawbList: function() {
      let self = this;
      self.$data.mawbs = [];
      getMawbs(this.item.issuerId)
        .then(function(data) {
          if(data.success === true) {
            self.$data.mawbs = data.item;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err){

        })
    },
    onMawbSelected: function() {
      for(let i = 0 ; i < this.$data.mawbs.length ; i++) {
        if(this.$data.mawbs[i].id === this.item.mawbId) {
          this.item.awb = this.$data.mawbs[i].airlineCode + '-' + this.$data.mawbs[i].number;
          return;
        }
      }
    },
    addNewHouseItem: function() {
      let newItem = createHouse();
      this.item.houses.push(newItem);
    },
    houseShipperChanged: function (index) {
      if (this.item == false) {
        return;
      }

      this.item.houses[index].shipperTitle = "";
      this.item.houses[index].shipperAddress1 = "";
      this.item.houses[index].shipperAddress2 = "";
      this.item.houses[index].shipperPostCode = "";

      for(let i = 0 ; i < this.merchants.length ;  i++) {
        if(this.item.houses[index].shipperId == this.merchants[i].id) {
          this.item.houses[index].shipperTitle = this.merchants[i].title.toUpperCase();
          this.item.houses[index].shipperAddress1 = this.merchants[i].address1.toUpperCase();
          this.item.houses[index].shipperAddress2 = this.merchants[i].address2.toUpperCase();
          this.item.houses[index].shipperPostCode = this.merchants[i].postCode.toUpperCase();
          return;
        }
      }

    },
    houseConsigneeChanged: function (index) {
      if (this.item === false) {
        return;
      }

      this.item.houses[index].consigneeTitle = "";
      this.item.houses[index].consigneeAddress1 = "";
      this.item.houses[index].consigneeAddress2 = "";
      this.item.houses[index].consigneePostCode = "";
      for(let i = 0 ; i < this.agents.length ;  i++) {
        if(this.item.houses[index].consigneeId === this.agents[i].id) {
          this.item.houses[index].consigneeTitle = this.agents[i].title.toUpperCase();
          this.item.houses[index].consigneeAddress1 = this.agents[i].address1.toUpperCase();
          this.item.houses[index].consigneeAddress2 = this.agents[i].address2.toUpperCase();
          this.item.houses[index].consigneePostCode = this.agents[i].postCode.toUpperCase();
          return;
        }
      }

    },
    deleteHouse: function(index) {

    },
    printManifest: function() {
      const FileDownload = require('js-file-download');
      // printManifest(this.item.id)
      //   .then(function(response) {
      //     // FileDownload(response.data, "manifest.pdf");
      //   })
      //   .catch(function(err) {
      //
      //   })
    },
    printHouseBill: function() {

    },
    printHouse: function(index) {
      let count = document.getElementById("house-print-count-" + index).value;
      // let houseId = this.item.houses[index].id;
      // printHouseLabel(houseId, count)
      //   .then(function(response) {
      //
      //   })
      //   .catch(function(err) {
      //
      //   })

    },
    closeItemForm: function() {
      console.log("close clicked");
      if(this.onClosed !== null) {
        console.log("close callback call");
        this.onClosed();
      }
    },
    submitManifest: function() {
      let self = this;
      let awb = '';
      if(this.item.awb1 !== null && this.item.awb1.length > 0) {
        awb = this.item.awb1 + '-';
      }
      if(this.item.awb2 !== null && this.item.awb2.length > 0) {
        awb += this.item.awb2;
      }
      if(this.item.awb3 !== null && this.item.awb3.length > 0) {
        awb += this.item.awb3;
      }
      this.item.awb = awb;
      let bkNoList = [];
      for(let i = 0 ; i < this.item.requests.length ; i++) {
        bkNoList.push(this.item.requests[i].requester + '-' + this.item.requests[i].urnCode);
      }
      if(bkNoList.length > 0) {
        this.item.bkNo = bkNoList.join(', ');
      }
      updateManifest(this.item)
        .then(function(data) {
          if(data.success === true) {
            if (self.onUpdated != null) {
              self.onUpdated(data.item);
            }
          } else {
            showDialog(data.message || 'Failed to save manifest.', 'ERROR');
          }
        })
        .catch(function(err) {
          showDialog((err && err.message) ? err.message : 'Failed to save manifest.', 'ERROR');
        })
    },
    formatPrice(value) {
      return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    getHouseTotalData: function() {

    },
    changeManifestWeights: function() {
      // let gw = document.getElementById("new-gw").value;
      // let vw = document.getElementById("new-vw").value;
      // let cw = document.getElementById("new-cw").value;
      //
      // if(gw == null || gw == '') {
      //   showDialog("Incorrect GW");
      //   return;
      // }
      // if(vw == null || vw == '') {
      //   showDialog("Incorrect VW");
      //   return;
      // }
      // if(cw == null || cw == '') {
      //   showDialog("Incorrect CW");
      //   return;
      // }
      // this.item.gw = Math.round(parseFloat(gw)* 100);
      // this.item.vw = Math.round(parseFloat(vw)* 100);
      // this.item.cw = Math.round(parseFloat(cw)* 100);
      // this.calculateHouseData();
      this.updateOtherCharge()
    },
    calculateHouseData: function() {

      console.log("calculateHouse Data cw:" + this.item.cw)
      this.item.total = Number(parseFloat(this.item.cw)/100*5.94 * 100);
      this.item.ahc = Number(parseFloat(this.item.cw)/100*0.11*100);
      if(this.item.ahc < 2400) {
        this.item.ahc = 2400;
      }
      this.item.avs = Number(parseFloat(this.item.cw)/100*0.15*100);
      if(this.item.avs < 1700) {
        this.item.avs = 1700;
      }
      this.item.fsc = Number(parseFloat(this.item.cw)/100*0.67*100);
      this.item.moc = Number(parseFloat(this.item.cw)/100*0.10*100);
    },
    printAwb: function() {
      const FileDownload = require('js-file-download');
      printMawb(this.item.id)
        .then(function(response) {
          // FileDownload(response.data, "mawb.pdf");
          // let reader = new FileReader();
          // reader.readAsDataURL(response.data);
          // reader.onloadend = function() {
          //   let base64data = reader.result;
          //   // printJS({
          //   //   printable: base64data,
          //   //   type: 'pdf',
          //   //   base64: true
          //   // })
          //   self.$data.pdfView = {
          //     src: 'data:application/pdf;base64,'+ base64data.replace("data:application/json;base64,", ""),
          //   };
          //   console.log(base64data);
          // }
        })
        .catch(function(err) {

        })
    },
    printDeliveryNote: function() {

    },
    closeAgentSelector: function() {
      this.$data.agentSelector = false;
    },
    openAgentSelector: function(field, type) {
      let self = this;
      this.$data.agentSelector = {
        type: type,
        onItemSelected: function(item) {

          if(field === 'consignee') {
            self.item.consigneeId = item.id;
            self.item.consigneeTitle = item.title;
            self.item.consigneeAddress1 = item.address1;
            self.item.consigneeAddress2 = item.address2;
            self.item.consigneeAddress3 = item.address3;
            self.item.consigneeTel = item.telephone;

          }
        }
      }
    },
    getCandidates: function() {
      let self = this;
      this.$data.candidateView = {
        requests:[],
        searchWord:'',
      };


    },
    searchList: function() {
      if(this.$data.candidateView.searchWord === null || this.$data.candidateView.searchWord.length < 2) {
        return;
      }
      let query = "stateFrom=0&stateTo=99&manifestId=0&searchName=" + this.$data.candidateView.searchWord;
      let self = this;
      searchRequests(query)
        .then(function(data) {
          console.log(data);
          if(data.success == true) {

            self.$data.candidateView.requests = data.item;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    selectRequest: function(request) {
      if(request.shippingMode !== 'AIR OUT') {
        showDialog("Shipping mode is not AIR OUT.");
        return;
      }
      request.manifestId = this.item.id;

      this.$data.candidateView = false;


      // let bkNoList = [];
      // for(let i = 0 ; i < this.item.requests.length ; i++) {
      //   let cbm = this.item.requests[i].cbm;
      //   if(this.item.requests[i].cbm === 0 && this.item.requests[i].preCbm > 0) {
      //     cbm = this.item.requests[i].preCbm
      //   }
      //   bkNoList.push(this.item.requests[i].requester +  cbm  + '-' + this.item.requests[i].urnCode);
      // }
      // if(bkNoList.length > 0) {
      //   this.item.bkNo = bkNoList.join(', ');
      // }
      let self = this;
      updateRequest(request)
        .then(function(data) {
          if(data.success === true) {
            self.item.requests.push(request);
            self.onRequestChanged();
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })

    },
    chargeChanged: function() {
      this.item.rate = Math.round(parseFloat(this.item.rateFloat)*100);
      this.item.total = 0;
      for(let i = 0 ; i < this.item.requests.length ; i++) {
        this.item.requests[i].chargeRate = this.item.rate;
        this.item.requests[i].chargeTotal = this.item.requests[i].kg * this.item.rate;
        this.item.total += this.item.requests[i].chargeTotal;
      }

      let self = this;
      updateRequests(this.item.requests)
        .then(function(data) {
          if(data.success === true) {
            self.item.requests = data.item;
            self.submitManifest();
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })



    },
    onRequestChanged: function() {

      let nop = 0;
      let gw = 0;
      let cw = 0;
      for(let i = 0 ; i < this.item.requests.length ; i++) {
        nop += this.item.requests[i].qty;
        gw += this.item.requests[i].kg;
        cw += this.item.requests[i].kg;
      }

      let totalCharge = cw * this.item.rate;

      this.item.nop = nop;
      this.item.gw = gw;
      this.item.total = totalCharge;
      this.chargeChanged();

    },
    onHouseItemClose: function() {
      this.$data.airHouseItem = false;
    },
    onHouseItemDeleted: function(item) {
      this.$data.airHouseItem = false;
      for(let i = 0 ; i < this.item.requests.length ; i++) {
        if (item.requestId === this.item.requests[i].id) {
          this.item.requests[i].house = null;

          return;
        }
      }
    },
    onHouseItemUpdated: function(house) {

       for(let i = 0 ; i < this.item.requests.length ; i++) {
         if(house.requestId === this.item.requests[i].id) {
           this.item.requests[i].house = house;
           // let found = false;
           // if(this.item.requests[i].house !== null && this.item.requests[i].house.id === house.id){
           //   this.item.req
           // }
           // if(this.item.requests[i].houses.length > 0) {
           //    for(let h = 0 ; h < this.item.requests[i].houses.length ; h++) {
           //      if(this.item.requests[i].houses[h].id === data.item.id) {
           //        this.item.requests[i].houses.splice(h, 1, data.item);
           //        found = true;
           //        break;
           //      }
           //    }
           //
           // }
           // if(found === false) {
           //   this.item.requests[i].houses.push(data.item)
           // }
         }

       }
    },
    createHouseItem: function(request) {
      let newItem = createHouse();
      newItem.manifestId = this.item.id;
      newItem.shipperTitle = request.requester;
      newItem.consigneeTitle = request.requester;

      newItem.shipperAddress1 = request.addressFrom;
      newItem.shipperTel = request.phoneNumber;
      newItem.consigneeAddress1 = request.addressTo;
      newItem.consigneeTel = request.destinationTel;

      newItem.consigneeEmail = request.email;
      newItem.requestId = request.id;
      newItem.cbm = request.cbm;
      newItem.kg = request.kg;
      newItem.gw = newItem.kg;
      if(newItem.gw > 0) {
        newItem.gwFloat = newItem.kg / 100.0;
      }
      newItem.cw = newItem.kg;
      newItem.cwFloat = newItem.gwFloat;
      newItem.nop = request.qty;
      newItem.blNumber = request.hbNo;
      newItem.volume = request.volume;

      newItem.pol = this.item.portOfLoading;
      newItem.pod = this.item.portOfDischarge;
      newItem.vessel = this.item.vessel;
      newItem.sealNumber = this.item.sealNumber;
      newItem.containerNumber = this.item.containerNumber;
      newItem.containerSize = this.item.containerSize;
      newItem.mblNo = this.item.mblNo;

      newItem.issuerTitle = 'UKO SHIPPING LTD';
      newItem.issuerAddress1 = 'CAKER STREAM ROAD';
      newItem.issuerAddress2 = 'ALTON, HAMPSHIRE';
      newItem.issuerPostCode = 'GU34 2QA';
      newItem.issuerTel = '01420 430 750';
      newItem.blNumber = request.reference;
      let self = this;
      updateHouse(newItem)
        .then(function(data) {
          if(data.success === true) {
            self.onHouseItemUpdated(data.item);
            self.openHouseItem(data.item.id);
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    unbindRequest: function(request) {
      request.manifestId = 0;
      let self = this;
      updateRequest(request)
        .then(function(data) {
          if(data.success === true) {
            for(let i = 0 ; i < self.item.requests.length ; i++) {
              if(self.item.requests[i].id === data.item.id) {
                self.item.requests.splice(i, 1);
                break;
              }
            }
            self.chargeChanged();

          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    openHouseItem: function(id) {
      let self = this;
      getHouse(id)
        .then(function(data){
          if(data.success === true) {
            self.$data.airHouseItem = data.item;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    deleteItem: function() {
      let self = this;
      this.$modal.show('dialog', {
        //title: '로그아웃',
        text: '현재 Manifest를 삭제하시겠습니까?',
        buttons: [
          {
            title: '아니요',
            handler: () => {
              self.$modal.hide('dialog');

            }
          },
          {
            title: '지우기',
            handler: () => {
              self.$modal.hide('dialog');

              self.deleteItemConfirmed();
            }
          },

        ]

      });
    },
    deleteItemConfirmed: function() {

      let self = this;
      deleteManifest(this.item.id)
        .then(function(data) {
          if(data.success === true) {
            console.log("delete item");
            console.log(data);
            if(self.onUpdated !== null) {
              self.onUpdated(data.item);
            }
            if(self.onClosed !== null) {
              self.onClosed();
            }
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          showDialog(err, "ERROR");
        })
    },
    updateOtherCharge: function() {
      if(this.item.ahcFloat !== null && this.item.ahcFloat !== '') {
        this.item.ahc = Math.round(parseFloat(this.item.ahcFloat)*100);
      } else {
        this.item.ahc = 0;
      }

      if(this.item.fscFloat !== null && this.item.fscFloat !== '') {
        this.item.fsc = Math.round(parseFloat(this.item.fscFloat)*100);
      } else {
        this.item.fsc = 0;
      }

      if(this.item.mocFloat !== null && this.item.mocFloat !== '') {
        this.item.moc = Math.round(parseFloat(this.item.mocFloat)*100);
      } else {
        this.item.moc= 0;
      }

      if(this.item.avsFloat !== null && this.item.avsFloat !== '') {
        this.item.avs = Math.round(parseFloat(this.item.avsFloat)*100);
      } else {
        this.item.avs = 0;
      }
      this.chargeChanged();
    },
    openEmailItem: function() {
      let documents = [];
      console.log("open email");
      console.log(this.item);

      if(this.item.bkNoDoc !== null && this.item.bkNoDoc.length > 0) {
        documents.push({
          title: 'BookingRef-WayBill',
          url:this.item.bkNoDoc,
        });
      }
      if(this.item.masterBill !== null && this.item.masterBill.length > 0) {
        documents.push({
          title: 'master bill',
          url:this.item.masterBill,
        });
      }

      if(this.item.blInstructionDoc !== null && this.item.blInstructionDoc.length > 0) {
        documents.push({
          title: 'BL Instruction',
          url: this.item.blInstructionDoc
        });
      }
      if(this.item.shippingAdviceDoc !== null && this.item.shippingAdviceDoc.length > 0) {
        documents.push({
          title: 'Shipping Advice',
          url: this.item.shippingAdviceDoc,
        })
      }
      for(let i = 0 ; i < this.item.documents.length ; i++) {
        documents.push(this.item.documents[i]);
      }

      let orderNumber = generateOrderNumber();
      for(let i = 0 ; i < this.item.requests.length ; i++) {
        if(this.item.requests[i].surveyForm !== null && this.item.requests[i].surveyForm !== null && this.item.requests[i].surveyForm.length > 0) {
          documents.push({
            title: "SurveyForm" + '-' + this.item.requests[i].requester + '-' + orderNumber,
            url: this.item.requests[i].surveyForm,
          })
        }
        if(this.item.requests[i].quotation !== null && this.item.requests[i].quotation.url !== null && this.item.requests[i].quotation.url.length > 0) {
          documents.push({
            title: this.item.requests[i].quotation.type.toUpperCase() + '-' + this.item.requests[i].quotation.shippingMode + '-' + this.item.requests[i].quotation.requester + '-' + (this.item.requests[i].quotation.total/100.0).toFixed(2) + '-' + generateOrderNumber(),
            url: this.item.requests[i].quotation.url,
          })
        }
        if(this.item.requests[i].invoice !== null && this.item.requests[i].invoice.url !== null && this.item.requests[i].invoice.url.length > 0) {
          documents.push({
            title: this.item.requests[i].invoice.type.toUpperCase() + '-' + this.item.requests[i].invoice.shippingMode + '-' + this.item.requests[i].requester + '-' + (this.item.requests[i].invoice.total/100.0).toFixed(2) + '-' + generateOrderNumber(),
            url: this.item.requests[i].invoice.url,
          })
        }

        if(this.item.requests[i].packingListDoc !== null && this.item.requests[i].packingListDoc.length > 0) {
          documents.push({
            title: 'Packing-List-' + this.item.requests[i].requester + '-' + this.item.requests[i].hbNo + '-' + this.item.requests[i].qty + '-' + orderNumber,
            url: this.item.requests[i].packingListDoc,
          });
        }
        if(this.item.requests[i].house !== null && this.item.requests[i].house.url !== null && this.item.requests[i].house.url.length > 0) {
          documents.push({
            title: this.item.requests[i].house.blNumber + '-' + this.item.requests[i].house.shipperTitle + '-' + orderNumber,
            url:this.item.requests[i].house.url,
          });
        }


        if(this.item.requests[i].packingInvoice !== null && this.item.requests[i].packingInvoice.length > 0) {
          documents.push({
            title:'Packing-Invoice-' + this.item.requests[i].requester  + '-' + orderNumber,
            url: this.item.requests[i].packingInvoice
          })
        }
        if(this.item.requests[i].approvalLetter !== null && this.item.requests[i].approvalLetter.length > 0) {
          documents.push({
            title:'Approval-Letter-' + this.item.requests[i].requester  + '-' + orderNumber,
            url: this.item.requests[i].approvalLetter
          })
        }

        if(this.item.requests[i].psid !== null && this.item.requests[i].psid.length > 0) {
          documents.push({
            title:'PSID-' + this.item.requests[i].requester  + '-' + orderNumber,
            url: this.item.requests[i].psid
          })
        }
        if(this.item.requests[i].commercialInvoice !== null && this.item.requests[i].commercialInvoice.length > 0) {
          documents.push({
            title:'Commercial-Invoice-' + this.item.requests[i].requester  + '-' + orderNumber,
            url: this.item.requests[i].commercialInvoice
          })
        }
        if(this.item.requests[i].tncAgreement !== null && this.item.requests[i].tncAgreement.length > 0) {
          documents.push({
            title:'TnC-Agreement-' + this.item.requests[i].requester  + '-' + orderNumber,
            url: this.item.requests[i].tncAgreement
          })
        }
        if(this.item.requests[i].reasonStatement !== null && this.item.requests[i].reasonStatement.length > 0) {
          documents.push({
            title:'Reason-Statement-' + this.item.requests[i].requester  + '-' + orderNumber,
            url: this.item.requests[i].reasonStatement
          })
        }
      }
      let to = "";
      if(this.item.notifyParty !== null && this.item.notifyParty.length > 0) {
        let lines = this.item.notifyParty.split("\n");
        for(let i = 0 ; i < lines.length ; i++) {
          // console.log(lines[i]);
          if(lines[i].startsWith("EMAIL: ")) {
            let emails = lines[i].replace("EMAIL: ", "");
            if(emails !== null && emails.length > 0) {
              to = emails.replaceAll(" ", "").toLowerCase();
            }
          }
        }
      }

      this.$data.emailItem = {
        item: {
          to:to,
          subject:'UKO Shipping Manifest ' + this.item.mblNo,
          body:'안녕하세요 UKO Shipping입니다.\n',
          documents:[],
        },
        documents:documents,
      }
    },
    closeEmailItem: function() {
      this.$data.emailItem = false;
    },

  }
}
</script>

<style scoped>
.house-bill>.row>* {
  border: 1px solid #000;
}
.weight-input-container > input {
  height: 38px;
  background: white;
  border: 1px solid #ccc;
  margin-right: 10px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/AirManifestView.vue